import { Divider, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Grid from "@mui/material/Grid2";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { setFinalBudgetData } from "../../../../../features/engagementIncentivesSlice";
import dayjs from "dayjs";

const DbReviewandSave = () => {
  const dispatch = useDispatch();
  const editedBudgets = useSelector(
    (state: any) => state.engagementIncentives?.editedBudgets || []
  );
  const duplicateTo = useSelector(
    (state: any) => state.engagementIncentives?.duplicateTo || ""
  );
  useEffect(() => {
    if (editedBudgets.length > 0 && duplicateTo) {
      const formattedData = {
        budgets: editedBudgets?.map((budget: any) => ({
          brand_shared_uid: budget.brand_shared_uid,
          month: duplicateTo, // Use the duplicateTo date from Redux
          cost_per_qftd: Number(budget.cost_per_qftd), // ensure it's a number
          qftd_amount: Number(budget.qftd_budget),
          links: budget.selected_links?.map(
            (link: any) => link.link_shared_uid
          ),
        })),
      };

      dispatch(setFinalBudgetData(formattedData));
    }
  }, [editedBudgets, duplicateTo, dispatch]);
  return (
    <Box sx={{ mt: 3 }}>
      <Typography sx={{ mb: 2 }}>
        {" "}
        Budget Period: {dayjs(duplicateTo).format("DD.MM.YYYY")}
      </Typography>
      <Box>
        {editedBudgets?.map((budget: any) => (
          <Box key={budget.brand_shared_uid}>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
              {budget.brand_name}
            </Typography>
            <Grid container spacing={2}>
              <Grid size={2}>
                <Typography variant="caption" color="text.secondary">
                  QFTD Amount
                </Typography>
                <Typography>{budget.cost_per_qftd}</Typography>
              </Grid>
              <Grid size={2}>
                <Typography variant="caption" color="text.secondary">
                  QFTD Budget
                </Typography>
                <Typography>{budget.qftd_budget}</Typography>
              </Grid>
              <Grid size={8}>
                <Typography variant="caption" color="text.secondary">
                  Links:
                </Typography>
                <Typography style={{ whiteSpace: "pre-line" }}>
                  {budget.selected_links
                    ?.map((link: any) => link.link_name)
                    .join("\n")}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        ))}
        {editedBudgets.length === 0 && (
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mt: 2, textAlign: "center" }}
          >
            No budget data to review. Please go back and select brands to
            duplicate.
          </Typography>
        )}
        <Divider sx={{ my: 2 }} />
      </Box>
    </Box>
  );
};

export default DbReviewandSave;
